import api from "./api";
import { isEmptyObj } from "./siteUtils";

export const creatingClues = async (user, membershipCode, comparisonToolApiBody) => {
  if (!user || !["MEMBERSHIP03", "MEMBERSHIP04"].includes(membershipCode) || isEmptyObj(comparisonToolApiBody)) return null;
  let body = comparisonToolApiBody;
  if (!body?.customerNumber) {
    body.customerNumber = user?.customerNumber || "";
  }
  const { code, obj, data } = await api.caseInfo.comparisonTool(null, body);
  if (code !== "1" || data.status === 404) {
    return null;
  } else if (obj) {
    return obj;
  }
};
